import { default as Content } from './Content'

export default Content
